export class EntEconomicActivityFilter {
    page: number = 1;
    size: number = 30;
    name: string | null = null;
    code: string | null = null;
    codeOrName: string | null = null;
    createdFrom: string | null = null;
    createdTo: string | null = null;
    deleted: boolean = false;
 }
